"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _date = require("@ha/date");

var minimumStayMonthsBuilder = function minimumStayMonthsBuilder(params) {
  if (params.startDate && params.endDate) {
    return "(minimumStayMonths<=" + (0, _date.getMonthsBetween)(params.startDate, params.endDate) + ")";
  }

  return '';
};

var _default = minimumStayMonthsBuilder;
exports["default"] = _default;